import React from 'react';

export const TooltipIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      data-testid="tooltip-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16675 9C2.16675 4.85786 5.52461 1.5 9.66675 1.5C13.8089 1.5 17.1667 4.85786 17.1667 9C17.1667 13.1421 13.8089 16.5 9.66675 16.5C5.52461 16.5 2.16675 13.1421 2.16675 9ZM15.6667 9C15.6667 5.68629 12.9805 3 9.66675 3C6.35458 3.00372 3.67047 5.68783 3.66675 9C3.66675 12.3137 6.35304 15 9.66675 15C12.9805 15 15.6667 12.3137 15.6667 9ZM10.4167 5.25V6.75H8.91675V5.25H10.4167ZM10.4167 8.25V12.75H8.91675V9.75H8.16675V8.25H10.4167Z"
        fill={props.fill || '#3461D5'}
      />
    </svg>
  );
};
